<!--这个是后台下面内容--侧边栏导航组件-->
<template>
	<div>
		<div class="left_nav_dv">
			<div class="zaixian_dv">
				<div	class="zaixian_dv2"	>
					图床-管理后台
				</div>
			</div>

			<ul class="lul1">
				<li class="lul1_li" v-for="(item , index) in $store.state.navList" :key='index' @click.stop="leftIndexActiveFun(item,index)"	
					@mouseover="mouseOverNavLeftFun(item,index)" 
					@mouseleave="mouseLeaveNavLeftFun(item,index)">
					<div class="nav_li_one " :class="{'hover_active' : item.isHover }">
						<div class="" :class="{'left_border' : item.isHover}"></div>
						<span :class="item.icon"></span>
						<p>{{item.title}}</p>
						<span class="icon iconfont icon-zuo iconzuojiantou" :class="{'left_nav_jaintou_active' : item.isShow ,'left_nav_jaintou_active2' : !item.isShow}" 
						v-if="item.children[0]"></span>
					</div>
					<el-collapse-transition>
						<div v-show="item.isShow">
							<ul class="lul2">
								<li  class="lul1_li" v-for="(item2 , index2) in item.children" :key="index2"  @click.stop="leftIndexActiveFun(item2,index)"	
									@mouseover="mouseOverNavLeftFun(item2,index)"
								 	@mouseleave="mouseLeaveNavLeftFun(item2,index)">
									<div class="nav_li_one nav_li_one2" :class="{'hover_active' : item2.isHover }">
										<div class="" :class="{'left_border' : item2.isHover}"></div>
										<span :class="item2.icon"></span>
										<p>{{item2.title}}</p>
									</div>
								</li>
							</ul>
						</div>
					</el-collapse-transition>
				</li>
			</ul>
			<div class="login_out_dv flex-row" @click="clickDialog">
				<span class="icon iconfont icon-tuichu"></span>
				<p>退出系统</p>
			</div>
		</div>
		<!-- 退出对话框 -->
		<el-dialog title="提示" :visible.sync="dialogOutVisible" width="30%">
			<span>是否退出操作？</span>
			<span slot="footer" class="dialog-footer">
			<el-button @click="dialogOutVisible = false">取 消</el-button>
			<el-button type="primary" @click="loginOut">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
	data() {
		return {
			navList:[],
			leftIndexActive: -1,    //点击选中的1级导航的索引
			//分页
			pageData: {
				pagecount: 1, //总页数  ,默认1
				pagesize: 10, //每页多少条  默认10
				pageindex: 1, //当前页  默认1
				count: 1,
			},
			dialogOutVisible: false,   //退出显示状态
		};
	},
	computed: {
		...mapGetters(["getUser"]),
	},
	created(){
		
	},
	methods: {
		//点击左边导航栏高亮
		leftIndexActiveFun(data,index) {
			//将数据更新到vuex---head标签
			if(data.navGrade == 1){
				//1级导航
				//重复点击
				if(this.leftIndexActive == index){
					//如果没有子数组
					if(data.children.length == 0){
						return false
					}else{
						this.$store.commit('tapLeftNavListFun',data)
						return false
					}
				}else{
					this.leftIndexActive = index
					//如果没有子数组
					if(data.children.length == 0){
						//将数据更新到vuex---head标签
						this.$store.commit('addTags',data)
						//将数据更新到vuex--
						this.$store.commit('tapLeftNavListFun',data)
						//跳转
						this.$router.push({ path:data.path });
					}else{
						this.$store.commit('tapLeftNavListFun',data)
					}
				}
			}else if(data.navGrade == 2){
				//2级导航
				this.$store.commit('addTags',data)
				//将数据更新到vuex--
				this.$store.commit('tapLeftNavListFun',data)
				//跳转
				this.$router.push({ path:data.path });
			}
		},
		/**
		 * 鼠标移入左边导航
		 * data  当前索引数据
		 * index 1级导航的索引
		 */
		mouseOverNavLeftFun(data,index){
			let obj = {
				'data':data,
				'index':index,
			}
			this.$store.commit('mouseOverNavLeftFun',obj)
		},
		/**
		 * 鼠标移出左边导航
		 * data  当前索引数据
		 * index 1级导航的索引
		 */
		mouseLeaveNavLeftFun(data,index){
			let obj = {
				'data':data,
				'index':index,
			}
			this.$store.commit('mouseLeaveNavLeftFun',obj)
		} ,
		//退出登录的弹窗
		clickDialog() {
			this.dialogOutVisible = true;
		},
		// 退出
		loginOut() {
			this.https(this.apiList.loginout).then((res) => {
                let resp = res.data;
                if (resp.code != "000") 
                    return this.$message.warning(resp.msg);
				this.$store.commit("userStatus", false);  // 设置vuex登录状态为false.
				this.tc_element(resp.message, resp.code, 2, "退出登录");   //弹窗提示
				this.dialogOutVisible = false;
				window.localStorage.clear();   // 清空缓存
                this.$router.push("/");   // 跳转到登录页
			});
		},
	},
 
};
</script>

<style lang="scss">
.left_nav_dv {
	position: fixed;
	top: 0;
	left: 0;
	z-index: 9;
	width: 210px;
	height: 100vh;
	// background-color: #2a3429;
	background-color: rgb(60, 68, 77);
	box-shadow: 5px 2px 10px rgba(0, 0, 0, 0.3980392157);
	.zaixian_dv {
		height: 80px;
		position: relative;
		// background-color:#1a2419;
		background-color: rgb(60, 68, 77);
		.zaixian_dv2 {
			padding-top: 15px;
			padding-left:10px;
			box-sizing: border-box;
			height: 100%;
			color:#fff;
			//background-color: #1a2419;
			background-color: rgb(60, 68, 77);

		}
	}
	.lul1 {
		// background-color: rgba(241, 244, 245, 1);
		background-color: rgb(60, 68, 77);
		.lul1_li:nth-child(1) , .lul1_li:nth-child(2){
			
		}
		.lul1_li {
			position: relative;
			cursor: pointer;
			width: 100%;
			text-align: center;
			line-height: 44px;
			font-size: 16px;
			// background-color: #2a3429;
			// background-color: rgb(60, 68, 77);
			background-color: rgb(53, 61, 68);
			&:hover{
				
			}
			.hover_active{
				//background-color: #000000;
				background-color: rgb(44, 49, 56);
				.left_border{
					display: block;
				}
			}
			.nav_li_one{
				padding-left:10px;
				box-sizing:border-box;
				display:flex;
				.left_nav_jaintou_active{
					transition:all 0.6s;/* 过度  */
					transform:rotate(630deg)!important;/* 旋转  */
				}
				.left_nav_jaintou_active2{
					transition:all 0.6s;/* 过度  */
					transform:rotate(180deg)!important;/* 旋转  */
				}
				.iconzuojiantou{
					font-size: 15px;
					position:absolute;
					top:0px;
					right:10px;
					transform:rotate(180deg);/* 旋转  */
				}
				.left_border{
					width:3px;
					height:44px;
					//background-color: #3c8dbc;
					background-color:rgb(32, 165, 58);
					position:absolute;
					top:0;
					left:0;
				}
				.toutai_name{
					font-size: 16px;
					line-height:20px;
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}
				span {
					font-size: 18px;
					//color: #fff;
					color: rgb(214, 215, 217);
					&:hover {
						color: #fff;
					}
				}
				p{
					//color: #fff;
					color: rgb(214, 215, 217);
					margin-left:10px;
				}
			}
			
			.lul2{
				padding-left:20px;
				box-sizing:border-box;
				.lul1_li{
					.nav_li_one2{
						//padding-left:30px;
						span {
							font-size: 14px;
							color: #fff;
						}
						p{
							font-size: 12px;
						}
					}
				}
			}
		}
	}
	.login_out_dv {
		border-top: 1px solid #555;
		background-color:#424d52;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 44px;
		text-align: center;
		line-height: 44px;
		cursor: pointer;
		span {
			margin:0 20px 0 40px;
			font-size: 24px;
		}
		p{
			color:#ccc;
		}
	}
}
</style>